import { Api } from '../api';
import { statements } from '../endpoints';
import type { ApiPaginate, FileResponse } from '../../models';
import type {
  DownloadSepaStatementRequest,
  DownloadStatementRequest,
  GenerateStatementOfFeesRequest,
  StatementsRequest,
  StatementsResponse,
} from './models';

export class StatementsApi extends Api {
  static getStatements = (request: StatementsRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<StatementsResponse[]>>({ url: statements.getStatements(), queryParams: request, signal });

  static download = (request: DownloadStatementRequest, signal?: AbortSignal) =>
    this.get<FileResponse>({ url: statements.downloadv1(), queryParams: request, signal });

  static downloadSepaStatement = (request: DownloadSepaStatementRequest, signal?: AbortSignal) =>
    this.get<FileResponse>({ url: statements.downloadSepaStatement(), queryParams: request, signal });

  static generateStatementOfFees = (request: GenerateStatementOfFeesRequest, signal?: AbortSignal) =>
    this.get<FileResponse>({ url: statements.generateStatementOfFees(), queryParams: request, signal });
}
